<template>
  <div class="ClueProtect-page">
    <h1>富士范儿活动报名个人信息保护声明</h1>
    <div class="content">
      <p style="text-indent: 28px;">保护用户个人信息是富士范儿的一项基本原则。富士范儿将按照本声明及《隐私协议》（链接地址:https://m.motortime.com/subaru-falv?source=5）的规定收集、使用、储存和分享您的个人信息。本声明未作明确规定的，以《隐私协议》的内容为准。若对个人信息保护规定的内容与上述《隐私协议》相冲突的，以本声明为准。 </p>
      <p><span style="font-weight:600;">一、个人信息的收集</span></p>
      <p>1、向您提供询价服务和组织专题活动是我们的基本业务功能，为了向您选择的经销商、销售顾问询问汽车价格，为了帮助您报名参与活动，以便为您提供更好的产品、服务，优化并丰富您的用户体验，我们将且仅收集与为您提供产品、服务有关的信息。 </p>
      <p>(1)当您向经销商询价或报名活动时，我们将收集：</p>
      <p>① 姓名；</p>
      <p>② 手机号码；</p>
      <p>③ 性别；</p>
      <p>④ 您在网站的表格上输入的其他信息（上牌城市等）；</p>
      <p>⑤ 根据法律规定，其他能够单独或者与其他信息结合识别您个人身份的信息。</p>
      <p>(2)当您向销售顾问询价或报名活动时，我们将收集：</p>
      <p>① 姓名；</p>
      <p>② 手机号码；</p>
      <p>③ 您在与顾问沟通过程中主动提供的其他信息；</p>
      <p>④ 根据法律规定，其他能够单独或者与其他信息结合识别您个人身份的信息。</p>
      <p>2、以上个人信息均是您自愿提供。您有权拒绝提供，但如果您拒绝提供某些个人信息，您将可能无法使用我们提供的产品、服务，或者可能对您使用产品、服务造成一定的影响。</p>
      <p>3、对于不满 14岁的用户，您需要让您的法定监护人阅读本声明并且同意提供您个人信息。</p>
      <p style="font-weight:600;">二、个人信息的使用和分享</p>
      <p>为了向您提供更完善、更优质的产品和服务，<span style="font-weight:600;">除非存在以下一种或多种情形，否则我们不会与任何第三方公司、组织和个人共享您的个人信息：</span></p>
      <p>(1) 基于您自行提出的要求、或事先获得您的明示授权或同意；</p>
      <p>(2) 与我们履行法律法规规定的义务相关的；</p>
      <p>(3) 与国家安全、国防安全直接相关的；</p>
      <p>(4) 与公共安全、公共卫生、重大公共利益直接相关的；</p>
      <p>(5) 与犯罪侦查、起诉、审判和判决执行等直接相关的；</p>
      <p>(6) 出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</p>
      <p>(7) 您自行向社会公众公开的您的个人信息；</p>
      <p>(8) 从合法公开披露的信息中收集个人信息的，如通过合法的新闻报道、政府信息公开等渠道;</p>
      <p>(9) 关联公司间共享：</p>
      <p>为便于我们基于富士范儿账号共同向您提供服务，或者向您推荐可能感兴趣的信息、保护提供富士范儿关联公司或其他用户或公众的人身财产安全免遭侵害，您的个人信息可能会在我们的关联公司间进行共享。我们只会共享您必要的个人信息，且这种共享受本政策所声明目的的约束。一旦我们共享您的个人信息或关联公司改变个人信息的处理目的，我们将会再次征求您的授权同意。 </p>
      <p>(10) 与相关汽车经销商、厂商及集团合作伙伴间共享：</p>
      <p>为了与您沟通您咨询的车型、定期或不定期地向您发送有关产品、服务或相关活动的信息以及向您提供更完善、优质的产品和服务，我们可能会与相关汽车经销商、厂商及集团共享您的某些个人信息。我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享为您提供服务所必要的个人信息。 </p>
      <p>
       <span style="font-weight:600;">请您知悉：该等共享的合作方为数据控制者，以其自己的名义获得您的同意以处理您的个人信息。合作方可能有其独立的隐私协议和用户协议，我们建议您认真阅读并遵守第三方的用户协议及隐私协议。</span>如果您拒绝我们的合作方在提供服务时收集为提供服务所必需的个人信息，将可能导致您无法在富士范儿应用中享用该合作方提供的服务。 
     </p>
     <p>若我们拟将信息用于其他用途，或者将基于特定目的收集而来的信息用于其他目的时，会事先征求您的同意。</p>
     <p><span style="font-weight:600;">三、更正或投诉</span></p>
     <p>如果您需要查询、修改或更正您的个人信息，或对个人信息保护问题有任何疑问或投诉，您可以拨打电话010-84425181或者发送邮件至kefu@motortime.com联系我们。</p>
     <p></p>
     <p></p>
     <p></p>
   </div>
 </div>
</template>

<script>
  export default {
    data () {
      return {
        name: '富士范儿'
      }
    },
    created () {
      this.$store.commit('param/show', false)
    // his.name = '凌志范儿'
    this.$appService.isShowReturn({state: true})
  //   let source = this.$store.state.param.source
  //   if(source == 3) {
  //     this.name = '汽车时间'
  //     this.$appService.isShowReturn({state: true})
  // } else if(source == 6) {
  //     this.name = '凌志范儿'
  //     this.$appService.isShowReturn({state: true})
  // }else if(source == 8) {
  //     this.name = '凌志范儿'
  //     this.$appService.isShowReturn({state: true})
  // }
},
methods: {

}
};
</script>

<style lang="scss">
  .ClueProtect-page {
    padding: 15px;
    background-color: #ffffff;

    h1 {
      font-size: 20px;
      margin: 5px 0 10px 0;
      text-align: center;
    }
    .content {

      h5 {
        font-size: 16px;
        margin: 10px 0 0 0;
      }
      p {
        margin: 10px 0 0 0;
        font-size: 14px;
      }
    }
  }
</style>
